import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from "react-hook-form";
import {
  PhoneInput,
  type IPhoneInputProps,
} from "@components/inputs/PhoneInput/PhoneInput";

export type TFormPhoneInputProps<T extends FieldValues> = IPhoneInputProps &
  UseControllerProps<T>;

export const FormPhoneInput = <T extends FieldValues>({
  name,
  control,
  ...rest
}: TFormPhoneInputProps<T>) => {
  const controller = useController({
    name,
    control,
  });

  const {
    field,
    fieldState: { error },
  } = controller;

  const { ref: fieldRef, ...fieldRest } = field;

  return (
    <PhoneInput
      {...rest}
      {...fieldRest}
      ref={fieldRef}
      error={error?.message}
      {...(rest.disabled ? { disabled: true } : {})}
      {...(rest.onBlur
        ? {
            onBlur: (e) => {
              rest.onBlur?.(e);
              fieldRest.onBlur?.();
            },
          }
        : {})}
    />
  );
};
